import {Component, OnInit, ViewChild, ɵConsole} from '@angular/core';
import {FormBuilder, FormGroup,FormControl, Validators,ReactiveFormsModule, AbstractControl  } from '@angular/forms';
//import Swal from "sweetalert2";
import { Router,ActivatedRoute } from "@angular/router";
//import { Observable } from "rxjs/Observable";
import { EmpresaService } from "../service/empresa/empresa.service";
import { DocumentoService } from "../service/documento/documento.service";
import {SecurityService} from "../service/security/security.service"
import {MatStepperModule,MatStepper} from '@angular/material/stepper'
import { Persona } from '../models/Persona';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { DatePipe } from "@angular/common";
import { HttpHeaders } from "@angular/common/http";
import { environment } from '../../environments/environment';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-validate-user',
  templateUrl: './validate-user.component.html',
  styleUrls: ['./validate-user.component.scss']
})
export class ValidateUserComponent implements OnInit {
  id_empresa=environment.ID_EMPRESA;
  id_user: any;
  token: any;
  pasoUno: FormGroup;
  loading: boolean = false;
  error: boolean = false;  
  data: any;
  mensajeError: string = "";
  hide = true;
  headers: HttpHeaders = new HttpHeaders();
  constructor(private loginService: SecurityService,private _route: ActivatedRoute,
    private router: Router,) {
      let user:string = this._route.snapshot.paramMap.get('user');
      let token:string = this._route.snapshot.paramMap.get('token');
    
      this.id_user = user;
      this.token = token;
    sessionStorage.clear();
    
   }

  ngOnInit() {
    this.pasoUno = new FormGroup({      
      usuario: new FormControl({ value: this.id_user, disabled: true }, [Validators.required,Validators.minLength(8),Validators.pattern("[0-9]{8}$")]),
      password: new FormControl('', [Validators.required]),
      repetir_Password: new FormControl('', [Validators.required]),
      token: new FormControl(this.token, [Validators.required]),
      id_empresa: new FormControl(this.id_empresa),
      id_usuario: new FormControl(this.id_user),
    },
    this.passwordsShouldMatch,);
     
    
    this.validar();

  }
  private passwordsShouldMatch(fGroup: FormGroup) {
    return fGroup.get('password').value === fGroup.get('repetir_Password').value
      ? null : {'mismatch': true};
  }
 
  validar(){
    if(!this.pasoUno.valid){
      //return;
    }
    this.headers = new HttpHeaders();
    this.loading = true;     
      this.loginService.validaToken(this.id_user,this.pasoUno.getRawValue()).subscribe(
        resp => {
          this.data = resp;
          this.error = false;
          this.loading = false;
          
          this.pasoUno.get("usuario").setValue(this.data.Usuario);
          //this.router.navigate(["/ending"]);          
        },
        err => {
          this.data = err;
          this.mensajeError = (this.data.error.error)?this.data.error.error:'Hubo un error en el servidor, contactarse a soporte.';
          this.pasoUno.get("password").setValue("");
          this.pasoUno.get("repetir_Password").setValue("");
          this.error = true;
          this.loading = false;
          return;
        }
      );
  }
  changePassword(){
    this.loading = true;
    if(this.pasoUno.invalid){
      this.loading = false;
      Swal.fire({
        icon: 'error',
        title: "Contraseña no válida",
        text: "Verificar que las contraseñas coincidan o que cumplan con los requisitos mínimos.",
        allowOutsideClick: false
      })
      return;
    }
    let form = new FormGroup({
      Usuario: new FormControl(this.data.Usuario, [Validators.required]),
      Password: new FormControl(this.pasoUno.get('password').value, [Validators.required]),
      Canal: new FormControl("W", [Validators.required]),
      Host: new FormControl("0", [Validators.required]),
      IP: new FormControl("0", [Validators.required]),
      NombreProyecto: new FormControl("Extranet", [Validators.required]),
      Ruc: new FormControl("0", [Validators.required]),
      id_empresa: new FormControl(this.id_empresa, [Validators.required]),
    });

     
      this.loginService.cambiarContraseña(this.pasoUno.getRawValue()).subscribe(
      resp => {
      this.data = resp;
      this.loading = false;
      Swal.fire({
        icon: "success",
        title: "¡Éxito!",
        text: "La contraseña ha sido modificada correctamente.",
        allowOutsideClick: true,
        showLoaderOnConfirm: true
      }).then(resp => {
        if (resp.value == true){
          this.router.navigate(['/login']);
          //sessionStorage.clear();
        }
      });

      },
      err => {
        this.loading = false;
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Usuario o Contraseña Incorrectos",
          allowOutsideClick: true
        });
      } 
 
    );



  }
}
